// Work-marketplace shared API (skills, projects, wallet, offers, chat, deliverables, feedback).
// Consumed by both the Architect and Freelancer apps. axiosInstance returns response.data directly.
import axiosInstance from "../api/axios";

// FastAPI List[...] query params -> repeated keys (?family=SOFTWARE style not needed here; single value).

// --- Skill catalog + freelancer self-ratings ---
export const getSkills = (family) =>
  axiosInstance.get("/arch/skills", { params: family ? { family } : {} });
export const getMySkills = () => axiosInstance.get("/arch/freelancers/me/skills");
export const upsertMySkills = (ratings) =>
  axiosInstance.put("/arch/freelancers/me/skills", { ratings });

// --- Projects (architect) ---
export const createProject = (data) => axiosInstance.post("/arch/projects", data);
export const listMyProjects = () => axiosInstance.get("/arch/projects");
export const getProject = (id) => axiosInstance.get(`/arch/projects/${id}`);
export const approveProject = (id) => axiosInstance.post(`/arch/projects/${id}/approve`);

// --- Wallet (architect) ---
export const getWallet = () => axiosInstance.get("/arch/wallet");

// --- Offers (freelancer) ---
export const listMyOffers = (activeOnly = false) =>
  axiosInstance.get("/arch/offers", { params: { active_only: activeOnly } });
export const acceptOffer = (offerId) => axiosInstance.post(`/arch/offers/${offerId}/accept`);
export const rejectOffer = (offerId) => axiosInstance.post(`/arch/offers/${offerId}/reject`);

// --- Chat (both parties) ---
export const listMessages = (projectId) =>
  axiosInstance.get(`/arch/projects/${projectId}/messages`);
export const postMessage = (projectId, body) =>
  axiosInstance.post(`/arch/projects/${projectId}/messages`, { body });

// --- Deliverables ---
export const listDeliverables = (projectId) =>
  axiosInstance.get(`/arch/projects/${projectId}/deliverables`);
export const submitDeliverable = (projectId, s3Keys, note) =>
  axiosInstance.post(`/arch/projects/${projectId}/deliverables`, { s3Keys, note });
export const reviewDeliverable = (projectId, action, feedback) =>
  axiosInstance.post(`/arch/projects/${projectId}/deliverables/review`, { action, feedback });

// --- Feedback (architect) ---
export const submitFeedback = (projectId, rating, comment) =>
  axiosInstance.post(`/arch/projects/${projectId}/feedback`, { rating, comment });
